import type { SpaceGits } from "@indietabletop/types";
import type { RepairLocation } from "./RepairLocation.ts";
import type { RepairProfile, Ruleset } from "./Ruleset.ts";

export class Repair {
  readonly ruleset: Ruleset;
  readonly location: RepairLocation;
  private data: RepairProfile;

  constructor(location: RepairLocation, data: RepairProfile) {
    this.ruleset = location.ruleset;
    this.location = location;
    this.data = data;
  }

  private get resolvedData(): Extract<RepairProfile, { fromMod?: false }> {
    const data = this.data;

    if (!data.fromMod) {
      return data;
    }

    const mod = this.ruleset.mods.get(data.id).valueOrNull();
    if (!mod) {
      return {
        id: data.id,
        selectOn: data.selectOn,
        name: "Unknown",
        description: `Referenced mod "${data.id}" not found.`,
        effects: [],
      };
    }

    return {
      id: data.id,
      name: mod.name,
      description: mod.description,
      effects: mod.effects ?? [],
      selectOn: data.selectOn,
    };
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.resolvedData.name;
  }

  get selectOn() {
    return this.data.selectOn;
  }

  get effects() {
    return this.resolvedData.effects;
  }

  get description() {
    return this.resolvedData.description;
  }

  get fromMod() {
    return this.data.fromMod ?? false;
  }

  matchesRef(ref: SpaceGits.RepairRef) {
    return ref.id === this.id && ref.locationId === this.location.id;
  }

  toRepairRef(): SpaceGits.RepairRef {
    return { locationId: this.location.id, id: this.id };
  }
}
